import React, { createRef, Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { CSAllocate } from "../_config.js";
import { GetCorService, genURL, gengetURLTEST } from "../_getjson.js";
import { AlertPopup } from "./AlertPopup";
import axios from 'axios'
import Backdrop from '../Components/CustomBackdrop/Barckdrop'
import Snackbar from '../Components/Snackbar/Snackbar'
require("./../_css/PopUpOther.css");

export default class PopUpOther extends Component {
  constructor(props) {
    super(props)
    this.Name = createRef();
    this.Productcode = createRef();
    this.Serialnumber = createRef();
    this.Warehouse = createRef();
    this.Location = createRef();
    this.state = {
      TextSearch: "",
      CHSearch: true,
      type: this.props.type,
      col: [],
      rows: [],
      valueRetuen: "",
      Htext: "",
      openBackdrop: false,
      messagealert: "",
    }
  }
  componentDidMount = e => {
    this.setState({
      selected: "1",
      autoClose: 3600,
    })
    // const months = ['March', 'Jan', 'Feb', 'Dec'];
    // months.sort();
    // console.log(months);
    this._chkload("Loadding");
    this.state.TextSearch = ""
    this.Name.current.value = ""
    this.loadData()
    //********************new by thanawat************************** */
  };


  loadData = async function () {
    var url = ""
    var dataArray = [];

    switch (this.props.type) {
      case "Department":
        this.setState({ openBackdrop: true })
        this.setState({ Htext: "แผนก", CHSearch: false });
        var url = "CSDEPARTMENT/GetAll?tablename=" + this.props.from + "&top=100&sitecode=" + this.props.userSite;
        if (this.state.TextSearch !== "") {
          if (this.state.selected === "0") {
            url = "CSDEPARTMENT/ByCode?tablename=" + this.props.from + "&code=" + this.state.TextSearch + "&sitecode=" + this.props.userSite;
          } else {
            url = "CSDEPARTMENT/ByName?tablename=" + this.props.from + "&name=" + this.state.TextSearch + "&sitecode=" + this.props.userSite;
          }
        }
        await console.log(genURL(url));
        // timeout 1 นาที
        await axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              dataArray[i] = await {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH
              };
            }
          } else {
            AlertPopup("Warning", "ไม่พบข้อมูล ");
            this.setState({ openBackdrop: false })
            return;
          }
        }).then(async _ => {
          await this.setState({ col: dataArray });
          this.setState({ openBackdrop: false })
        })
          .catch(error => {
            this.setState({ openBackdrop: false })
            this._chkload("Error" + error);
          });
        break;
      case "Project":
        this.setState({
          col: [
            { number: 1, code: "01", text: "เขตการขาย1" },
            { number: 2, code: "02", text: "เขตการขาย2" },
            { number: 3, code: "03", text: "เขตการขาย3" },
            { number: 4, code: "04", text: "เขตการขาย4" },
            { number: 5, code: "05", text: "เขตการขาย5" },
            { number: 6, code: "06", text: "เขตการขาย6" },
            { number: 7, code: "07", text: "เขตการขาย7" },
            { number: 8, code: "08", text: "เขตการขาย8" },
            { number: 9, code: "09", text: "เขตการขาย9" },
            { number: 10, code: "10", text: "เขตการขาย10" },
            { number: 11, code: "11", text: "เขตการขาย11" },
            { number: 12, code: "AS001", text: "ศูนย์ SYM" }
          ],
          Htext: "โครงการ"
        });
        break;
      case "Incometype":
        this.setState({ openBackdrop: true })
        this.setState({ Htext: "เลือกรายการ-CSINCOMETYPE", CHSearch: false });
        console.log(this.props.from);
        url = "CSINCOMETYPE/Search?All="
        if (this.state.TextSearch !== "") {
          if (this.state.selected === "0") {
            url = "CSINCOMETYPE/Search?Code=" + this.state.TextSearch
          }
          else {
            url = "CSINCOMETYPE/Search?Name=" + this.state.TextSearch
          }
        }
        await console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
          if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              dataArray[i] = {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH,
                taxgroup: res.data[i].WTAXRATE,
              }
            }
          } else {
            AlertPopup("Warning", "ไม่พบข้อมูล ");
            this.setState({ openBackdrop: false })
            return;
          }
        }).then(async _ => {
          await this.setState({ col: dataArray });
          this.setState({ openBackdrop: false })
        })
          .catch(error => {
            this._chkload("Error" + error);
            this.setState({ openBackdrop: false })
          });

        break;
      case "taxtype":
        this.setState({ openBackdrop: true })
        this.setState({ Htext: "เลือกรายการ-CSWTAXTYPE", CHSearch: false });
        console.log(this.props.from);
        url = "CSWTAXTYPE/Search?All="
        if (this.state.TextSearch !== "") {
          if (this.state.selected === "0") {
            url = "CSWTAXTYPE/Search?Code=" + this.state.TextSearch
          }
          else {
            url = "CSWTAXTYPE/Search?Name=" + this.state.TextSearch
          }
        }
        await console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
          if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              dataArray[i] = {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH
              }
            }
          } else {
            AlertPopup("Warning", "ไม่พบข้อมูล ");
            this.setState({ openBackdrop: false })
            return;
          }
        }).then(async _ => {
          await this.setState({ col: dataArray });
          this.setState({ openBackdrop: false })
        })
          .catch(error => {
            this._chkload("Error" + error);
            this.setState({ openBackdrop: false })
          });

        break;
      case "Groupdata":
        console.log(this.props.userSite);
        this.setState({ openBackdrop: true })
        this.setState({ Htext: "กลุ่มข้อมูล", CHSearch: false });
        console.log(this.props.from);

        url = `CSDOCGROUP/Docgroupaspermission?tablename=` + this.props.from + `&txtsearch=` + this.state.TextSearch +
          `&usercode=` + localStorage.getItem("Username") + `&typesearch=` + this.state.selected + `&top=300&sitecode=` + this.props.userSite;

        await console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
          if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              dataArray[i] = {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH
              }
            }
          } else {
            // AlertPopup("Warning", "ไม่พบข้อมูล ");
            this.setState({ openBackdrop: false })
            return;
          }
        }).then(async _ => {
          await this.setState({ col: dataArray });
          this.setState({ openBackdrop: false })
        })
          .catch(error => {
            this._chkload("Error" + error);
            this.setState({ openBackdrop: false })
          });

        break;
      case "Groupdata1":
        this.setState({ openBackdrop: true })
        this.setState({ Htext: "เลือกรายการ-CSTAXGROUP", CHSearch: false });
        url = "CSTAXGROUP/Gettaxgtoup?Data="
        if (this.state.TextSearch !== "") {
          url = "CSTAXGROUP/Gettaxgtoup?Data=" + this.state.TextSearch
        }
        await console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
          if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              dataArray[i] = {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH,
                taxgroup: res.data[i].TAXGROUP,
                taxformat: res.data[i].TAXFORMAT,
              }
            }
          } else {
            AlertPopup("Warning", "ไม่พบข้อมูล ");
            this.setState({ openBackdrop: false })
            return;
          }
        }).then(async _ => {
          await this.setState({ col: dataArray });
          this.setState({ openBackdrop: false })
        })
          .catch(error => {
            this._chkload("Error" + error);
            this.setState({ openBackdrop: false })
          });

        break;
      case "Groupdataall":
        this.setState({ openBackdrop: true })
        this.setState({ Htext: "เลือกรายการ-CSTAXGROUP", CHSearch: false });
        url = "CSDOCGROUP/All?tablename=" + this.props.from + "&Usercode=" + localStorage.getItem("Username") + "&top=300"
        if (this.state.TextSearch !== "") {
          if (this.state.selected === "0") {
            url = "CSDOCGROUP/Searchbycode?tablename=" + this.props.from + "&txt=" + this.state.TextSearch + "&Usercode=" + localStorage.getItem("Username") + "&top=300&sitecode=" + this.props.userSite;
          }
          else {
            url = "CSDOCGROUP/Searchbyname?tablename=" + this.props.from + "&txt=" + this.state.TextSearch + "&Usercode=" + localStorage.getItem("Username") + "&top=300&sitecode=" + this.props.userSite;
          }
        }
        await console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
          if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              dataArray[i] = {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH,
              }
            }
          } else {
            AlertPopup("Warning", "ไม่พบข้อมูล ");
            this.setState({ openBackdrop: false })
            return;
          }
        }).then(async _ => {
          await this.setState({ col: dataArray });
          this.setState({ openBackdrop: false })
        })
          .catch(error => {
            this._chkload("Error" + error);
            this.setState({ openBackdrop: false })
          });
        break;
      case "Allocation":
        var url = CSAllocate(0);
        this.setState({ Htext: "การจัดสรร" });
        GetCorService(url)
          .then(res => {
            for (let i = 0; i < res.data.length; i++) {
              dataArray[i] = {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH
              };
            }
          })
          .then(_ => {
            this.setState({ col: dataArray });
          })
          .catch(error => {
            this._chkload("Error");
          });
        break;
      case "CreditCode":
        this.setState({
          col: [
            { number: 1, code: "C00", text: "เงินสด" },
            { number: 2, code: "C03", text: "เครดิต 3 วัน" },
            { number: 3, code: "C05", text: "เครดิต 5 วัน" },
            { number: 4, code: "C07", text: "เครดิต 7 วัน" },
            { number: 5, code: "C120", text: "เครดิต 120 วัน" },
            { number: 6, code: "C15", text: "เครดิต 15 วัน" },
            { number: 7, code: "C30", text: "เครดิต 30 วัน" },
            { number: 8, code: "C45", text: "เครดิต 45 วัน" },
            { number: 9, code: "C55", text: "เครดิต 55 วัน" },
            { number: 10, code: "C60", text: "เครดิต 60 วัน" },
            { number: 11, code: "C90", text: "เครดิต 90 วัน" }
          ],
          Htext: "รหัสเครดิต"
        });
        break;
      case "Branch":
        this.setState({ openBackdrop: true })
        this.setState({ Htext: "สาขา", CHSearch: false });
        if (this.state.selected === "0") {
          var url = "CSSITE/Getsite?Code=" + this.state.TextSearch + "&user=" + localStorage.getItem("Username");
        } else {
          var url = "CSSITE/Getsite?Name=" + this.state.TextSearch + "&user=" + localStorage.getItem("Username");
        }
        await console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              dataArray[i] = {
                number: i + 1,
                code: res.data[i].CODE,
                text: res.data[i].MYNAMETH
              }
            }
          } else {
            AlertPopup("Warning", "ไม่พบข้อมูล ");
            this.setState({ openBackdrop: false })
            return;
          }
        }).then(async _ => {
          await this.setState({ col: dataArray });
          this.setState({ openBackdrop: false })
        }).catch(error => {
          this._chkload("Error" + error);
          this.setState({ openBackdrop: false })
        });
        break;
      case "Expcode":
        if (this.state.TextSearch !== "") {
          url = "CSINCOME/NAMETH?tablename=" +
            this.props.from +
            "&code=" +
            this.state.TextSearch +
            "&name=" +
            localStorage.getItem("name") +
            "&sitecode=" +
            this.props.name;
        }
        var Url = "CSINCOME/NAMETH?tablename=" + this.props.from + "&name=" + this.state.TextSearch;
        GetCorService(Url)
          .then(res => {
            var data = res.data;
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                dataArray[i] = {
                  number: i + 1,
                  code: data[i].CODE,
                  text: data[i].MYNAMETH
                };
              }
            } else {
              console.log("4");
              AlertPopup("Warning", "ไม่พบข้อมูล ");
              return;
            }
          })
          .then(_ => {
            this.setState({ col: dataArray });
          });
        break;

      case "Issuetype":

        console.log("Issuetype case");
        console.log("Issuetype selected", this.state.selected);
        console.log("Issuetype TextSearch", this.state.TextSearch);

        url = "CSISSUETYPE/";
        let Codewt = "GETCODE?Code=";
        let Namewt = "GETNAME?Name=";
        let Allwt = "GETALL?";
        if (this.state.selected === "1" && this.state.TextSearch !== "") {
          ////console.log('value!="" && by=="1"');
          url += Namewt + this.state.TextSearch;
          //console.log(url); 
        } else if (this.state.selected === "0" && this.state.TextSearch !== "") {
          url += Codewt + this.state.TextSearch;
        } else if (this.state.TextSearch === "") {
          url += Allwt;
        }

        console.log("Issuetype", url);
        var arrdata = [];
        GetCorService(url).then(res => {
          var data = res.data
          try {
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                arrdata[i] = {
                  number: i + 1,
                  code: data[i].CODE,
                  text: data[i].MYNAMETH,
                }
              }
            }
          } catch (error) {
            return "error"
          }

        }
        ).finally(_ => {
          this.setState({ col: arrdata })
        }
        )
        console.log("Issuetype", arrdata);
        break;



      default: break;
    }
    setTimeout(() => {
      this.onSearch();
    }, 300);
  }
  onSelectRow = data => {
    this.setState({ valueRetuen: data.code + "|" + data.text });
    this.props.Get_PopUpOther(data.code + "|" + data.text + "|" + data.taxgroup + "|" + data.taxformat);
    this.props.closePopup();
  };
  onSearch = data => {
    /* console.log(data); */
    if (!data) {
      this.setState({ rows: this.state.col });
    } else {
      console.log("else");
      let rows = [];
      var t1 = "";
      var dataSe = data.target.value;
      var j = 0;
      for (let i = 0; i < this.state.col.length; i++) {
        if (
          this.state.col[i].text.search(dataSe) !== -1 ||
          this.state.col[i].code.search(dataSe) !== -1
        ) {
          rows[j] = {
            number: j + 1,
            code: this.state.col[i].code,
            text: this.state.col[i].text
          };
          j++;
        }
      }
      this.setState({ rows: rows });
      this._chkload("Nodata");
    }

    // this.setState({ TextSearch: event.target.value });
    // setTimeout(() => {
    //     this.componentDidMount();
    // }, 100);
  };
  onSearchDataclick = data => {
    if (!data) {
      this.setState({ rows: this.state.col });
    } else {
      let rows = [];
      var t1 = "";
      var dataSe = data.target.value;
      var j = 0;
      for (let i = 0; i < this.state.col.length; i++) {
        if (
          this.state.col[i].text.search(dataSe) !== -1 ||
          this.state.col[i].code.search(dataSe) !== -1
        ) {
          rows[j] = {
            number: j + 1,
            code: this.state.col[i].code,
            text: this.state.col[i].text
          };
          j++;
        }
      }
      this.setState({ rows: rows });
      this._chkload("Nodata");
    }
  };
  SearchData = event => {
    if (event.key === "Enter") {
      this.setState({ TextSearch: event.target.value });
      setTimeout(() => {
        this.componentDidMount();
      }, 100);
    }
  };
  _chkload = status => {
    switch (status) {
      case "Error":
        this.setState({ loadding: "ไม่สามารถโหลดข้อมูลได้" });
        break;
      case "Nodata":
        this.setState({ loadding: "ไม่พบข้อมูล" });
        break;
      case "Loadding":
        this.setState({
          loadding: (
            <div align="center">
              กำลังโหลดข้อมูล
            </div>
          )
        });
        break;
    }
  };
  _onBlur = event => {
    this.setState({ txtinput: event.target.value });
  };
  _clickSearch = () => {
    this.setState({ TextSearch: this.state.txtinput });
    setTimeout(() => {
      this.componentDidMount();
    }, 100);
  };
  reloadBtnClick = () => {
    this.loadData()
  }

  onClickSearch = () => {
    this.loadData()
  }
  textinputKeyUp = (e) => {
    var txt = e.target.value;
    this.setState({ TextSearch: txt })
    if (e.key === 'Enter') {
      this.loadData();
    }
  }
  render() {
    const ROW_HEIGHT = 150;
    return (
      <div className="popup">
        <Backdrop open={this.state.openBackdrop} />
        <Snackbar place="br"
          color={this.state.color}
          icon={this.state.icon}
          autoClose={this.state.autoClose}
          message={this.state.messagealert}
          open={this.state.opensnackbar}
          closeNotification={() => { this.setState({ opensnackbar: false }) }}
          close />

        <div className="popup_inner">
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-search"> {this.state.Htext} </i>
            </div>
            <div className="PopUpOtherDivH2">
              <i className="fas fa-times" onClick={this.props.closePopup}></i>
            </div>
          </div>
          <div className="panel-body divTable" align="left">
            <div>
              <div className="form-inline">
                <div className="form-group mb-2">
                  <input type='radio' id='Choice-1' name='myRadio' value='0'
                    checked={this.state.selected === "0"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                  <input type='radio' id='Choice-2' name='myRadio' value='1'
                    checked={this.state.selected === "1"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;</span>
                </div>
              </div>
            </div>
            <div className="input-group width-grop" >
              <input type="text" className="form-control" placeholder="กรอกคำค้นหา" onKeyUp={this.textinputKeyUp} ref={this.Name} />
              <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={this.onClickSearch}></i></span>
              <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.componentDidMount() }}></i></span>
            </div>
            <BootstrapTable
              data={this.state.rows}
              options={{
                onRowClick: this.onSelectRow,
                _chkload: this.state.loadding,
                noDataText: 'ไม่พบข้อมูล'
              }}
              height="700" condensed
            >
              <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="5%" dataField="number" isKey></TableHeaderColumn>
              <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="40%" dataField="code" dataSort>  รหัส</TableHeaderColumn>
              <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="55%" dataField="text">  ชื่อ/คำอธิบาย</TableHeaderColumn>
              <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="300" dataField="taxgroup" rowSpan="2" hidden></TableHeaderColumn>
              <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="300" dataField="taxformat" rowSpan="2" hidden></TableHeaderColumn>
            </BootstrapTable>

          </div>
        </div>
      </div>
    );
  }
}
///////////////////////////////////////////////////ดึงอ้างอิงจากสั่งจองสินค้า ///////////////////////////////////////////////////
export class DocNoRef extends Component {
  state = {
    Table: 1,
    casschkbox: "far fa-square",
    casschkboxs: false
  };
  componentDidMount = e => {
    this.AddDataTable1();
  };
  AddDataTable1 = e => {
    var url = "CSV_SALEREFDOCNO2/Code?arcode=" + this.props.CustomerCode;
    GetCorService(url).then(res => {
      var dataArray = res.data;
      for (let i = 0; i < dataArray.length; i++) {
        dataArray[i].number = i + 1;
        var myDate = new Date(dataArray[i].DOCDATE);
        var date = myDate.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var month = myDate.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var year = myDate.getFullYear() + 543;
        dataArray[i].DOCDATE = date + "/" + month + "/" + year;
        dataArray[i].SB = "0";
        if (i === dataArray.length - 1) {
          /// ทำงานเสร็จให้เพิ่มข้อมูล
          this.setState({ dataTable1: dataArray });
        }
      }
    });
  };
  AddDataTable2 = Code => {
    var url = "CSV_SALEREFDOCNO2/Codesub?strDOCNO=" + Code;
    console.log(url);
    GetCorService(url).then(res => {
      console.log(res.data);
      var dataArray = res.data;
      for (let i = 0; i < dataArray.length; i++) {
        dataArray[i].number = i + 1;
        if (i === dataArray.length - 1) {
          /// ทำงานเสร็จให้เพิ่มข้อมูล
          this.setState({ dataTable2: dataArray });
          this.setState({ Table: 2 });
        }
      }
    });
  };
  onSelectRowDocNoRef = (data, col, id) => {
    if (col === 1) {
    } else if (col > 1) {
      if (this.state.Table === 1) {
        var docno = "";
        var dataArray = this.state.dataTable1;
        var sb_length = 0;
        for (
          var i = 0;
          i < this.state.dataTable1.length && this.state.dataTable1[i].DOCNO;
          i++
        ) {
          if (this.state.dataTable1[i].SB === 1) {
            sb_length = sb_length + 1;
            docno = docno + "&docno=" + this.state.dataTable1[i].DOCNO;
          }
        }
        setTimeout(() => {
          this.AddDataTable2(docno);
        }, 200);
      } else {
        this.props.Get_PopUpOther("DocNoRef", data);
        this.props.closePopup();
      }
    }
  };
  SelectAll = e => {
    this.props.Get_PopUpOther("DocNoRef", this.state.dataTable2);
    this.props.closePopup();
  };
  //onClick checkbox
  cellcheckbok = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.dataTable1[rowIndex].SB;
    var btnShow;
    switch (btn) {
      case "0":
        btnShow = (
          <span>
            <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")} > </i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span>
            <i className=""> </i>
          </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  //เปลี่ยนสถานะ checkbox
  Update_Status = (Row, Status) => {
    if (Status === "ALL") {
      if (this.state.casschkboxs === false) {
        //กด checkbox เลือกทั้งหมด
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });

        var dataArray = this.state.dataTable1;
        for (var i = 0; i < this.state.dataTable1.length && this.state.dataTable1[i].DOCNO; i++) {
          dataArray[i].SB = "1";
        }
        this.setState({ dataTable1: dataArray });
      } else {
        //กด checkbox ไม่เลือก
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });

        var dataArray = this.state.dataTable1;
        for (var i = 0; i < this.state.dataTable1.length && this.state.dataTable1[i].DOCNO; i++) {
          dataArray[i].SB = "0";
        }
        this.setState({ row: dataArray });
      }
    } else {
      //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
      if (Status === "0") {
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: false });
      }

      //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
      var dataArray = this.state.dataTable1;
      dataArray[Row].SB = Status;
      this.setState({ dataTable1: dataArray });

      //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
      var sb_length = 0;
      console.log(this.state.dataTable1.length);
      for (
        var i = 0;
        i < this.state.dataTable1.length && this.state.dataTable1[i].Col1;
        i++
      ) {
        if (this.state.dataTable1[i].SB === 1) {
          sb_length = sb_length + 1;
        }
      }
      if (sb_length === this.state.dataTable1.length) {
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: true });
      }
    }
  };
  render() {
    return (
      <div className="popup">
        <div className="popup_inner divBox">
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-at"> เอกสารอ้างอิงขาย </i>
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          {this.state.Table === 1 ? (
            <div className="panel-body DivTable" align="right">
              <div className="DivTable">
                <BootstrapTable
                  data={this.state.dataTable1}
                  options={{ onRowClick: this.onSelectRowDocNoRef, _chkload: this.state.loadding }}
                  height="1000" hover condensed>
                  <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="5%" dataField="number" isKey></TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="5%" dataField="SB" editable={false} dataAlign="center"
                    dataFormat={this.cellcheckbok.bind(this)}>
                    <div onClick={this.Update_Status.bind(null, "", "ALL")}>
                      <i style={{ fontSize: "20px" }} className={this.state.casschkbox}></i>
                    </div>
                  </TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="DOCNO" dataAlign="left" width='20%'>  <div align="center"> เลขที่เอกสาร </div></TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="DOCDATE" dataAlign="center" width="20%">  วันที่เอกสาร</TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="SALECODE" dataAlign="center" width="10%">  พนักงานขาย</TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="CREDITCODE" dataAlign="center" width="5%">  รหัสเครดิต</TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="REMARK" dataAlign="center" width="20%">  หมายเหตุ</TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="DEBTAMOUNT" dataAlign="center" width="10%">  จำนวนเงิน</TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="TYPE" dataAlign="center" width="5%">  ชนิดเอกสาร</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          ) : (
            <div className="panel-body DivTable" align="left">
              <button className="DocNoRef_Ison" onClick={e => { this.setState({ Table: 1 }); }}> <i className="fas fa-reply-all"> กลับ </i></button>
              <span className="pipe"></span>
              <button className="DocNoRef_Ison" onClick={this.SelectAll}>  <i className="fas fa-clone"> ทั้งหมด </i></button>
              <div className="DivTable">
                <BootstrapTable
                  data={this.state.dataTable2}
                  options={{ onRowClick: this.onSelectRowDocNoRef, _chkload: this.state.loadding }}
                  height="1000" hover condensed
                >
                  <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="5%" dataField="number" isKey></TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="DOCNO" dataAlign="left" width="20%">  <div align="center"> เลขที่เอกสาร </div></TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="PRODUCTCODE" dataAlign="left" width="25%">  <div align="center"> รหัสสินค้า </div></TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="PRODUCTNAME" dataAlign="left" width="25%">  <div align="center"> ชื่อสินค้า </div></TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="UNITCODE" dataAlign="center" width="5%"> หน่วย</TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="QUANTITY" dataAlign="center" width="10%"> ปริมาณ</TableHeaderColumn>
                  <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="UNITPRICE" dataAlign="center" width="10%"> ราคา/หน่วย</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export class SERIALNUMBER extends Component {
  state = {
    Table: 1,
    PRODUCTCODE: this.props.PRODUCTCODE,
    SERIALNUMBER: "",
    WAREHOUSE: this.props.WAREHOUSE,
    LOCATION: this.props.LOCATION
  };
  componentDidMount = e => {
    this.Productcode.current.value = this.state.PRODUCTCODE;
    this.Warehouse.current.value = this.state.WAREHOUSE;
    this.Location.current.value = this.state.LOCATION;
    this.AddDataTable1();
  };
  AddDataTable1 = e => {
    var url = "CSV_SEL_SERIAL/Code?PRODUCTCODE=" + this.Productcode.current.value + "&SERIALNUMBER="
      + this.Serialnumber.current.value + "&WAREHOUSE=" + this.Warehouse.current.value + "&LOCATION=" + this.Location.current.value;
    // url = "CSV_SEL_SERIAL/Code?PRODUCTCODE=11-B21300-BK"+"&SERIALNUMBER="+"&WAREHOUSE=809"+"&LOCATION=8091";
    GetCorService(url).then(res => {
      var dataArray = res.data;
      for (var i = 0; i < res.data.length; i++) {
        dataArray[i].C0 = i + 1;
      }
      this.setState({ dataTable1: dataArray });
    });
  };

  onSelectRowDocNoRef = data => {
    this.props.Get_PopUpOther("SERIALNUMBER", data);
    this.props.closePopup();
  };

  SERIALNUMBER_keyPress = e => {
    if (e.key === "Enter") {
      this.AddDataTable1();
    }
    if (e.target.id === "WAREHOUSE") {
      setTimeout(() => {
        this.Location.current.value = this.Warehouse.current.value + "1";
      }, 20);
    }
  };

  render() {
    return (
      <div className="popup">
        <div className="popup_inner divBox">
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-at"> SERIALNUMBER </i>
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <div className="panel-body DivTable" align="left">
            <div className="row">
              <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon"> รหัสสินค้า : </span>
                  <input type="text" className="form-control" ref={this.Productcode} disabled />
                </div>
              </div>
              <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6">
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon"> เลขตัวถัง : </span>
                  <input type="text" className="form-control" ref={this.Serialnumber} onKeyPress={this.SERIALNUMBER_keyPress.bind(null)} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-xs-6 col-sm-5 col-lg-5 col-md-5">
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon"> คลัง : </span>
                  <input type="text" className="form-control" id="WAREHOUSE" ref={this.Warehouse} onKeyPress={this.SERIALNUMBER_keyPress.bind(null)} />
                </div>
              </div>
              <div className="form-group col-xs-6 col-sm-5 col-lg-5 col-md-5">
                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <span className="input-group-addon"> ที่เก็บ : </span>
                  <input type="text" className="form-control" ref={this.Location} onKeyPress={this.SERIALNUMBER_keyPress.bind(null)} />
                </div>
              </div>
              <button
                onClick={this.AddDataTable1}
                type="button"
                className="btn btn-primary"
                style={{ padding: "5px 10px 3px 10px" }}
              >
                <i className="fas fa-search"></i>
              </button>
            </div>

            <div className="DivTable">
              <BootstrapTable
                data={this.state.dataTable1}
                options={{ onRowClick: this.onSelectRowDocNoRef, _chkload: this.state.loadding }}
                height="420" hover condensed>
                <TableHeaderColumn dataField="C0" isKey width="2%" dataAlign="center"></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField="SERIALNUMBER" dataAlign="left" width="95%">  <div align="center"> SERIALNUMBER </div></TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const CreditCode = Code => {
  var text = " ";
  switch (Code) {
    case "C00":
      text = "เงินสด";
      break;
    case "C03":
      text = "เครดิต 3 วัน";
      break;
    case "C05":
      text = "เครดิต 5 วัน";
      break;
    case "C07":
      text = "เครดิต 7 วัน";
      break;
    case "C120":
      text = "เครดิต 120 วัน";
      break;
    case "C15":
      text = "เครดิต 15 วัน";
      break;
    case "C30":
      text = "เครดิต 30 วัน";
      break;
    case "C45":
      text = "เครดิต 45 วัน";
      break;
    case "C55":
      text = "เครดิต 55 วัน";
      break;
    case "C60":
      text = "เครดิต 60 วัน";
      break;
    case "C90":
      text = "เครดิต 90 วัน";
      break;
    default:
      break;
  }
  return text;
};

// new by kate
